import { copyToClipboard } from './utils';

const BUTTON_TEXT = 'Copy';
const COPIED_TEXT = 'Copied';

export const loadCodeCopies = () => {
  document.querySelectorAll('pre code').forEach((div) => new CodeCopy(div));
};

class CodeCopy {
  constructor(div) {
    this.div = div;
    this.insertBtn();
  }

  insertBtn = () => {
    this.div.insertAdjacentHTML('beforeend', `<div class="btn-copy">${BUTTON_TEXT}</div>`);
    this.btn = this.div.lastChild;
    this.btn.addEventListener('click', this.click);
  };

  click = (e) => {
    if (this.btn.classList.contains('active')) return;
    e.preventDefault();
    copyToClipboard(this.div.childNodes[0].textContent);
    this.btn.textContent = COPIED_TEXT;
    this.btn.classList.add('active');
    setTimeout(() => {
      this.btn.textContent = BUTTON_TEXT;
      this.btn.classList.remove('active');
    }, 1500);
  };
}
